import NiceModal, { useModal } from '@ebay/nice-modal-react'
import UnmarkPurchaseModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkPurchaseModal'
import { Reservation } from 'src/types/reservation'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import { showUnmarkedAsPurchasedToast } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/UnmarkedAsPurchasedToast'
import css from './DeleteContributionModal.styles.scss'
import { DeleteContributionModalProps } from './DeleteContributionModal.types'

const TOAST_TEXT = 'Contribution deleted.'

const DeleteContributionModal = NiceModal.create(
  ({ reservation }: DeleteContributionModalProps) => {
    const modal = useModal()
    const { registry } = useGetRegistry(reservation.registryId.toString())

    const resolveModal = (res?: Reservation) => {
      modal.resolve(res)
      modal.hide()
    }

    const handleUnmarkedAsPurchased = (res: Reservation) => {
      showUnmarkedAsPurchasedToast(registry, TOAST_TEXT)
      resolveModal(res)
    }

    const handleClose = () => resolveModal()

    return (
      <UnmarkPurchaseModal
        handleClose={handleClose}
        handleDismount={modal.remove}
        isOpen={modal.visible}
        reservation={reservation}
        onUnmarkedAsPurchased={handleUnmarkedAsPurchased}
      >
        <p className={css.DeleteContributionModal__Body}>
          Here's what you need to know:
        </p>
        <ol className={css.DeleteContributionModal__NumberedList}>
          <li>This contribution will be deducted from your funded amount.</li>
          <li>
            We'll remove this gift from your gift tracker and thank you list.
          </li>
        </ol>
      </UnmarkPurchaseModal>
    )
  }
)

export default DeleteContributionModal
